import { render, staticRenderFns } from "./SitchImageUpload.vue?vue&type=template&id=79bfa8a9&scoped=true&"
import script from "./SitchImageUpload.vue?vue&type=script&lang=ts&"
export * from "./SitchImageUpload.vue?vue&type=script&lang=ts&"
import style0 from "./SitchImageUpload.vue?vue&type=style&index=0&id=79bfa8a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bfa8a9",
  null
  
)

export default component.exports